import axios, { AxiosResponse, AxiosRequestConfig } from "axios";

const _axiosClient = axios.create();

// Ambiente DEV
_axiosClient.defaults.baseURL = `${process.env.REACT_APP_URL_API_INTEGRACOES}/vitat`;

// _axiosClient.defaults.auth = {
// 	username: 'ampl1m3d',
// 	password: 'Ampl1@m3dP455w01',
// };

_axiosClient.defaults.headers.common.Authorization = window.sessionStorage.getItem("token") || "";

interface IAmpliAxios {
	getUri(config?: AxiosRequestConfig): string;
	request<T = any, R = AxiosResponse<T>, D = any>(config: AxiosRequestConfig<D>): Promise<AxiosResponse<T>>;
	get<T = any, R = AxiosResponse<T>, D = any>(url: string, config?: AxiosRequestConfig<D>): Promise<AxiosResponse<T>>;
	delete<T = any, R = AxiosResponse<T>, D = any>(url: string, config?: AxiosRequestConfig<D>): Promise<AxiosResponse<T>>;
	head<T = any, R = AxiosResponse<T>, D = any>(url: string, config?: AxiosRequestConfig<D>): Promise<AxiosResponse<T>>;
	options<T = any, R = AxiosResponse<T>, D = any>(url: string, config?: AxiosRequestConfig<D>): Promise<AxiosResponse<T>>;
	post<T = any, R = AxiosResponse<T>, D = any>(url: string, data?: D, config?: AxiosRequestConfig<D>): Promise<AxiosResponse<T>>;
	put<T = any, R = AxiosResponse<T>, D = any>(url: string, data?: D, config?: AxiosRequestConfig<D>): Promise<AxiosResponse<T>>;
	patch<T = any, R = AxiosResponse<T>, D = any>(url: string, data?: D, config?: AxiosRequestConfig<D>): Promise<AxiosResponse<T>>;
}

export const getUserToken = async (): Promise<string | null> => {
	const url: URL = new URL(window.location.href);
	const params: URLSearchParams = url.searchParams;

	let token = params.get("token");
	const insurance = params.get("insurance") ?? '';

	if (token && token != "null") {
		const config: AxiosRequestConfig<any> = {
			headers: {
				Authorization: token || "",
			},
		};
		const response = await _axiosClient.get("token-info", token ? config : {});
		if (response.status !== 401) {
			window.sessionStorage.setItem("token", token);
			window.sessionStorage.setItem("insuranceName", insurance || ""); 
			window.sessionStorage.setItem("user_data", JSON.stringify(response.data));
			return token;
		} else {
			token = window.sessionStorage.getItem("token");
		}
	} else {
		token = window.sessionStorage.getItem("token");
	}
	return token;
};

const getConfig = (token: string | null, config?: AxiosRequestConfig<any>): AxiosRequestConfig<any> => {
	if (!config) config = {};
	if (!config.headers) config.headers = {};
	config.headers.Authorization = token || "";
	return config;
};

const axiosClient: IAmpliAxios = {
	getUri: (config?: AxiosRequestConfig): string => {
		return _axiosClient.getUri(config);
	},
	request: async <T = any, R = AxiosResponse<T> | { status: number }, D = any>(config: AxiosRequestConfig<D>): Promise<R> => {
		const token = await getUserToken();
		config = getConfig(token, config);
		return await _axiosClient.request(config);
	},
	get: async <T = any, R = AxiosResponse<T>, D = any>(url: string, config?: AxiosRequestConfig<D>): Promise<AxiosResponse<T>> => {
		try {
			const token = await getUserToken();
			config = getConfig(token, config);
			return await _axiosClient.get(url, config);
		} catch (err) {
			if (axios.isAxiosError(err)) {
				if (err.request.status == 401) window.location.href = "/unauthorized";
				throw err;
			} else {
				throw err;
			}
		}
	},
	delete: async <T = any, R = AxiosResponse<T>, D = any>(url: string, config?: AxiosRequestConfig<D>): Promise<AxiosResponse<T>> => {
		try {
			const token = await getUserToken();
			config = getConfig(token, config);
			return await _axiosClient.delete(url, config);
		} catch (err) {
			if (axios.isAxiosError(err)) {
				if (err.request.status == 401) window.location.href = "/unauthorized";
				throw err;
			} else {
				throw err;
			}
		}
	},
	head: async <T = any, R = AxiosResponse<T>, D = any>(url: string, config?: AxiosRequestConfig<D>): Promise<AxiosResponse<T>> => {
		try {
			const token = await getUserToken();
			config = getConfig(token, config);
			return await _axiosClient.head(url, config);
		} catch (err) {
			if (axios.isAxiosError(err)) {
				if (err.request.status == 401) window.location.href = "/unauthorized";
				throw err;
			} else {
				throw err;
			}
		}
	},
	options: async <T = any, R = AxiosResponse<T>, D = any>(url: string, config?: AxiosRequestConfig<D>): Promise<AxiosResponse<T>> => {
		let token: string | null = "";
		try {
			token = await getUserToken();
			config = getConfig(token, config);
			return await _axiosClient.options(url, config);
		} catch (err) {
			if (axios.isAxiosError(err)) {
				if (err.request.status == 401) window.location.href = "/unauthorized";
				throw err;
			} else {
				throw err;
			}
		}
	},
	post: async <T = any, R = AxiosResponse<T>, D = any>(url: string, data?: D, config?: AxiosRequestConfig<D>): Promise<AxiosResponse<T>> => {
		try {
			const token = await getUserToken();
			config = getConfig(token, config);
			return await _axiosClient.post(url, data, config);
		} catch (err) {
			if (axios.isAxiosError(err)) {
				if (err.request.status == 401) window.location.href = "/unauthorized";
				throw err;
			} else {
				throw err;
			}
		}
	},
	put: async <T = any, R = AxiosResponse<T>, D = any>(url: string, data?: D, config?: AxiosRequestConfig<D>): Promise<AxiosResponse<T>> => {
		let token: string | null = "";
		try {
			token = await getUserToken();
			config = getConfig(token, config);
			return await _axiosClient.put(url, data, config);
		} catch (err) {
			if (axios.isAxiosError(err)) {
				if (err.request.status == 401) window.location.href = "/unauthorized";
				throw err;
			} else {
				throw err;
			}
		}
	},
	patch: async <T = any, R = AxiosResponse<T>, D = any>(url: string, data?: D, config?: AxiosRequestConfig<D>): Promise<AxiosResponse<T>> => {
		let token: string | null = "";
		try {
			token = await getUserToken();
			config = getConfig(token, config);
			return await _axiosClient.patch(url, data, config);
		} catch (err) {
			if (axios.isAxiosError(err)) {
				if (err.request.status == 401) window.location.href = "/unauthorized";
				throw err;
			} else {
				throw err;
			}
		}
	},
};

export default axiosClient;
